export default "__VITE_ASSET__d096f900__"